<template>
  <app-form-group
    :label="label"
    :placeholder="placeholder"
    :error="error"
    :state="computedState"
    :size="size"
    :variant="variant"
    :disabled="disabled"
    :focused="isFocused"
    :icon-class="iconClass"
    :tooltip="tooltip"
    @clickIcon="onClickIcon"
    :class="{ 'is-password': isPassword }"
  >
    <b-form-input
      :id="safeId"
      :type="inputType"
      :value="value"
      v-numeric="isNumber"
      v-length="length"
      :state="computedState"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
      :pattern="pattern"
      :size="size"
      :disabled="disabled"
      :autocomplete="autocomplete"
    />
  </app-form-group>
</template>

<script>
import formMixin from "@/mixins/forms/form";
import formTextMixin from "@/mixins/forms/text";
import AppFormGroup from "@/components/form/FormGroup";

export default {
  name: "AppFormInput",
  components: { AppFormGroup },
  mixins: [formMixin, formTextMixin],
  props: {
    type: {
      type: String,
      required: false,
      default: "text",
    },
    pattern: {
      type: String,
      required: false,
      default: null,
    },
    length: {
      type: Number,
      required: false,
      default: null,
    },
  },
  computed: {
    inputType() {
      if (!this.isPassword) {
        return this.type;
      }

      return this.visiblePassword ? "text" : "password";
    },
    isPassword() {
      return this.type === "password";
    },
    isNumber() {
      return this.type === "number";
    },
    iconClass() {
      if (!this.isPassword || !this.lazyValue) {
        return null;
      }

      return this.visiblePassword ? "icon-eye" : "icon-eye-slash";
    },
  },
  methods: {
    onInput(value) {
      this.lazyValue = value;
      this.$emit("input", value || null);
    },
    onFocus() {
      this.focused_ = true;
    },
    onBlur() {
      if (this.lazyValue) {
        return;
      }

      this.focused_ = false;
    },
    onClickIcon() {
      if (!this.isPassword) {
        return;
      }

      this.visiblePassword = !this.visiblePassword;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.lazyValue = value;
        this.focused_ = !!value;
      },
      immediate: true,
    },
  },
  data() {
    return {
      visiblePassword: false,
      lazyValue: this.value,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  &.is-password {
    ::v-deep {
      .icon {
        cursor: pointer;
      }
    }
  }
  ::v-deep {
    input[type="number"] {
      -moz-appearance: textfield;
    }
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
